export const statusStyle: Record<string, string> = {
  request: "bg-amber-50 text-amber-600",
  approve: "bg-green-100 text-green-700",
  reject: "bg-red-50 text-red-600",
  cancel: "bg-gray-100 text-gray-500",
};

export const vehicleStatusStyle: Record<string, string> = {
  pending: "bg-amber-50 text-amber-600",
  approved: "bg-green-100 text-green-700",
  rejected: "bg-red-50 text-red-600",
  cancelled: "bg-gray-100 text-gray-500",
};

export const VEHICLE_STATUS_KO: Record<string, string> = {
  pending: "대기",
  approved: "승인",
  rejected: "반려",
  cancelled: "취소",
};

export type UnifiedRow = {
  key: string;
  type: "place" | "vehicle";
  name: string;
  time: string;
  date: string;
  detail: string;
  statusLabel: string;
  statusClass: string;
  fullDate: string;
  userName: string;
  telNo: string;
};

export const formatTime = (t: string) => {
  if (!t || t.length < 4) return "";
  return `${t.slice(0, 2)}:${t.slice(2, 4)}`;
};
